/**
 * AI Exam Funnel Tracker
 * Tracks 1st vs 2nd AI exam completion for signup/subscription gates
 */

const STORAGE_KEY = 'aiExamCompletionCount';

export const aiExamFunnelTracker = {
  getCount(): number {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? parseInt(stored, 10) : 0;
    } catch {
      return 0;
    }
  },

  increment(): number {
    const count = this.getCount() + 1;
    localStorage.setItem(STORAGE_KEY, String(count));
    return count;
  },

  /** Before increment: count 0 = about to complete 1st exam */
  isFirstExam(): boolean {
    return this.getCount() === 0;
  },

  /** Before increment: count 1 = about to complete 2nd exam */
  isSecondExam(): boolean {
    return this.getCount() === 1;
  },

  /** After increment: count 1 = just completed 1st exam (signup gate) */
  isAfterFirstExam(): boolean {
    return this.getCount() === 1;
  },

  /** After increment: count >= 2 = just completed 2nd+ exam (subscription gate) */
  isAfterSecondExam(): boolean {
    return this.getCount() >= 2;
  },
};
